module.exports = __webpack_public_path__ + "img/productcenter_img.77dfb581.png";